module.exports = __webpack_public_path__ + "media/images/covers/PrepWorks_Student-Testimonial_Nurazreen_Poster-c39d3eb3d17c47a07ab4fa03eed09dc1.webp";